export const FSM_SETTINGS_FORM_SEARCH = "FSM_SETTINGS_FORM_SEARCH";
export const FSM_SETTINGS_FORM_SEARCH_RESPONSE = "FSM_SETTINGS_FORM_SEARCH_RESPONSE";
export const FSM_SETTINGS_FORM_CREATE = "FSM_SETTINGS_FORM_CREATE";
export const FSM_SETTINGS_FORM_CREATE_RESPONSE = "FSM_SETTINGS_FORM_CREATE_RESPONSE";
export const FSM_SETTINGS_FORM_UPDATE = "FSM_SETTINGS_FORM_UPDATE";
export const FSM_SETTINGS_FORM_UPDATE_RESPONSE = "FSM_SETTINGS_FORM_UPDATE_RESPONSE";
export const FSM_SETTINGS_FORM_DELETE = "FSM_SETTINGS_FORM_DELETE";
export const FSM_SETTINGS_FORM_DELETE_RESPONSE = "FSM_SETTINGS_FORM_DELETE_RESPONSE";
export const FSM_SETTINGS_FORM_OPEN_CREATE_EDIT= "FSM_SETTINGS_FORM_OPEN_CREATE_EDIT";
export const FSM_SETTINGS_FORM_OPEN_DELETE= "FSM_SETTINGS_FORM_OPEN_DELETE";